const options = {
  5: "bg-lime-900/5",
  10: "bg-lime-900/10",
  25: "bg-lime-900/25",
  50: "bg-lime-900/50",
  75: "bg-lime-900/75",
  90: "bg-lime-900/90",
  100: "bg-lime-900",
};

const from = {
  5: "from-lime-900/5",
  10: "from-lime-900/10",
  25: "from-lime-900/25",
  50: "from-lime-900/50",
  75: "from-lime-900/75",
  90: "from-lime-900/90",
  100: "from-lime-900",
};

export default function getBackgroundLime900(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
